type SubItem = {
  title: string;
  href: string;
};

export type MenuItem = {
  title: string;
  href: string;
  subitems?: SubItem[];
};

export const menuOptions: MenuItem[] = [
  {
    title: "Kurumsal",
    href: "",
    subitems: [
      { title: "Hakkımızda", href: "" },
      { title: "Yönetim", href: "" },
      { title: "Politika Belgeleri", href: "" },
      { title: "WHO Bağlantısı", href: "" },
    ],
  },
  {
    title: "SKB Üyeliklerimiz",
    href: "",
    subitems: [
      { title: "Üye Nasıl Olunur?", href: "" },
      { title: "Üye Şehirlerimiz", href: "" },
      { title: "Üye İlçelerimiz", href: "" },
    ],
  },
  {
    title: "Haberlerimiz",
    href: "",
    subitems: [
      { title: "Manşetler", href: "" },
      { title: "SKB Haberleri", href: "" },
      { title: "Belediye Haberleri", href: "" },
    ],
  },
  {
    title: "Projelerimiz",
    href: "",
    subitems: [
      { title: "Devam Eden Projeler", href: "" },
      { title: "Tamamlanmış Projeler", href: "" },
    ],
  },
  {
    title: "Etkinliklerimiz",
    href: "",
    subitems: [
      { title: "2025'teki Etkinlikler", href: "" },
      { title: "2024'teki Etkinlikler", href: "" },
      { title: "2023'teki Etkinlikler", href: "" },
      { title: "2022'deki Etkinlikler", href: "" },
    ],
  },
  {
    title: "İçeriklerimiz",
    href: "",
    subitems: [
      { title: "KENTLİ Dergisi", href: "" },
      { title: "Sürdürülebilir Eylem Planı", href: "" },
      { title: "Blog", href: "" },
      { title: "Yayınlarımız", href: "" },
    ],
  },
  {
    title: "Medya",
    href: "",
    subitems: [
      { title: "Blog", href: "" },
      { title: "Haberler", href: "" },
    ],
  },
  {
    title: "İletişim",
    href: "",
  },
];
